// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__oygrI","content":"GlobalSearch_content__26VSH"};